const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 26.441 24"
  >
    <g fill={color} stroke="none" strokeWidth="1.803" color={color}>
      <path
        d="M13.22 0c-.626 0-1.252.298-1.579.893l-.01.019-3.543 6.726-5.125-4.391-.025-.02c-.625-.508-1.532-.496-2.122-.112-.59.383-.968 1.206-.757 1.984l.002.005 3.407 12.32a2.414 2.414 0 0 0 2.301 1.764h14.904a2.414 2.414 0 0 0 2.3-1.764l3.408-12.32V5.1c.212-.778-.167-1.603-.757-1.986-.589-.383-1.496-.396-2.121.113l-.023.019-5.127 4.393L14.81.912l-.01-.02C14.472.299 13.847 0 13.22 0m0 3.053 3.013 5.719.007.012c.71 1.309 2.497 1.656 3.644.708l.018-.014 3.634-3.113-2.88 10.418H5.785L2.903 6.363 6.538 9.48l.016.014c1.148.948 2.937.6 3.647-.708l.007-.012z"
      ></path>
      <path
        d="M4.802 21.595A1.2 1.2 0 0 0 3.6 22.797 1.2 1.2 0 0 0 4.802 24h16.836a1.2 1.2 0 0 0 1.201-1.203 1.2 1.2 0 0 0-1.2-1.202z"
      ></path>
    </g>
  </svg>
);

export default SvgIcon;
